module.exports = __webpack_public_path__ + "img/html-evolution-9.92ce9a45.webp";